import React from "react";
import { Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { inputCls, Label } from "./fields";

const OPTIONS = [
  { key: "phone", label: "Phone call", icon: Phone },
  { key: "email", label: "Email", icon: EnvelopeSimple },
];

export function ContactMethodField({ form, setForm }) {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const isPhone = form.contact_method === "phone";
  return (
    <div>
      <Label>How would you like us to contact you?</Label>
      <div role="radiogroup" className="grid grid-cols-2 gap-2 mb-2.5">
        {OPTIONS.map(({ key, label, icon: Icon }) => {
          const on = form.contact_method === key;
          return (
            <button key={key} type="button" role="radio" aria-checked={on} data-testid={`ticket-contact-${key}`}
              onClick={() => setForm((f) => ({ ...f, contact_method: key }))}
              className={`flex items-center justify-center gap-2 rounded-xl border px-3 py-2.5 text-sm transition-colors ${on ? "border-[#73bf44] bg-[#73bf44]/10 text-white font-semibold" : "border-neutral-700 text-neutral-400 hover:text-white hover:border-neutral-500"}`}>
              <Icon size={16} weight={on ? "fill" : "regular"} className={on ? "text-[#73bf44]" : ""} /> {label}
            </button>
          );
        })}
      </div>
      {isPhone ? (
        <input key="phone" data-testid="ticket-phone-input" type="tel" inputMode="tel" autoComplete="tel" value={form.phone} onChange={set("phone")}
          className={inputCls} placeholder="Your phone number, e.g. 04xx xxx xxx" maxLength={30} />
      ) : (
        <input key="email" data-testid="ticket-email-input" type="email" inputMode="email" autoComplete="email" value={form.email} onChange={set("email")}
          className={inputCls} placeholder="you@example.com" maxLength={120} />
      )}
    </div>
  );
}
